import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema, findColumn } from '@blaze-shared/schema-domain';
import { UnionWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('Union')
export class UnionNode extends BaseWorkflowNode<UnionWorkflowNode> {
  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    const inputSchemas = [...schemas.keys()]
      .filter((key) => typeof key === 'string' && key.startsWith('input'))
      .map((key) => schemas.get(key))
      .filter((schema) => !!schema);

    const missingColumns = this.node.projectColumns.filter(
      (col) => !inputSchemas.some((schema) => findColumn(schema.columns, col)),
    );

    return missingColumns?.length
      ? missingColumns.map((column) => ({
          columns: [column],
          sourceId: undefined,
          schemaId: undefined,
        }))
      : [];
  }

  getTagReferences(_schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [];
  }

  getParamReferences(
    _schemas: Map<string | symbol, BaseSchema>,
    _connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [];
  }

  getNamedInputReferences(
    _schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [];
  }
}
